module.exports = __webpack_public_path__ + "static/media/4.abc79dc5.png";